export default {
  'menu.projects': 'プロジェクト管理',
  'menu.projects.all': 'すべてのプロジェクト',
  'menu.projects.participated': '参加中',
  'menu.projects.following': 'フォロー中',
  'menu.projects.tagManagement': 'タグ管理',
  'menu.estimationStandards': '工数見積基準管理',
  'menu.devAgents': '開発Agent管理',
  'menu.projectHome': 'プロジェクトホーム',
  'menu.projectCharter': 'プロジェクト規約',
  'menu.projectCharter.projectGoals': '目標とビジョン',
  'menu.projectCharter.projectPrinciples': '原則',
  'menu.projectCharter.projectNotes': '注意事項',
  'menu.productInput': 'プロダクト入力',
  'menu.productInput.inputDashboard': '入力ボード',
  'menu.productInput.issuesIdea': 'アイデア',
  'menu.productInput.issuesRequest': '要件リード',
  'menu.productInput.referenceProducts': '参照製品',
  'menu.productInput.referenceMaterials': '資料リンク',
  'menu.productInput.userFeedback': 'ユーザーフィードバック',
  'menu.productInput.easyRecorder': 'Easy Recorder',
  'menu.requirementDefinition': '要件定義',
  'menu.requirementDefinition.summary': '要件概要',
  'menu.requirementDefinition.overviewTemplateManagement':
    '概要要件テンプレート',
  'menu.requirementDefinition.featureList': '機能一覧',
  'menu.requirementDefinition.roleAnalysis': 'ロール分析',
  'menu.requirementDefinition.conceptAnalysis': '概念分析',
  'menu.requirementDefinition.systemIntegration': 'システム連携',
  'menu.requirementDefinition.document': '要件ドキュメント',
  'menu.deliveryPlanning': 'デリバリー計画',
  'menu.deliveryPlanning.issuesStory': 'デリバリーストーリー',
  'menu.deliveryPlanning.taskManagement': 'タスク管理',
  'menu.deliveryPlanning.estimationStandards': '見積基準',
  'menu.deliveryPlanning.taskListGeneration': 'タスクリスト生成',
  'menu.developmentDesign': '開発設計',
  'menu.developmentDesign.applicationAnalysis': 'アプリ分析',
  'menu.developmentDesign.repositoryManagement': 'アプリ構築',
  'menu.developmentDesign.modelingAssistant': 'データモデリング',
  'menu.developmentDesign.aiAssistedDesign': 'プロトタイプ設計',
  'menu.developmentDesign.architecture': 'アーキテクチャ設計',
  'menu.developmentDesign.apiManagement': 'API管理',
  'menu.developmentExecution': '開発実行',
  'menu.developmentExecution.agentManagement': 'Agent管理',
  'menu.developmentExecution.codeRepository': 'コード管理',
  'menu.developmentExecution.codeMigration': 'コード移行',
  'menu.testQuality': 'テスト品質',
  'menu.testQuality.testManagement': 'テスト管理',
  'menu.testQuality.issuesBug': '欠陥',
  'menu.testQuality.qualityAnalysis': '品質分析',
  'menu.projectAssets': 'プロジェクト資産',
  'menu.projectAssets.assetLibrary': '素材ライブラリ',
  'menu.projectAssets.daily-report-management': '日報管理',
  'menu.projectAssets.quote-management': '見積管理',
  'menu.projectAssets.auditLog': '監査ログ',
  'menu.productionDashboard': '生産ダッシュボード',
  'menu.projectDashboard': '生産ダッシュボード',
  'menu.projectDashboard.dashboard': 'ダッシュボード',
  'menu.dailyManagement': '日常管理',
  'menu.dailyManagement.taskManagement': 'タスク管理',
  'menu.dailyManagement.communicationRecords': 'コミュニケーション記録',
  'menu.dailyManagement.issueTracker': '課題管理',
  'menu.dailyManagement.issueTracker.bug': 'Bug',
  'menu.dailyManagement.issueTracker.userFeedback': 'ユーザーフィードバック',
  'menu.dailyManagement.issueTracker.risk': 'リスク',
  'menu.dailyManagement.issueTracker.problem': '問題',
  'menu.dailyManagement.issueTracker.changeRequest': '変更要求',
  'menu.dailyManagement.issueTracker.pendingConfirmation': '確認待ち',
  'menu.dailyManagement.dailyReportManagement': '日報管理',
  'menu.requirementAnalysis': '要件分析',
  'menu.requirementAnalysis.requirementPool': '要件プール',
  'menu.requirementAnalysis.structuredAnalysis': '構造化分析',
  'menu.requirementAnalysis.highLevelRequirements': '概要要件',
  'menu.requirementAnalysis.featureList': '機能一覧',
  'menu.requirementAnalysis.prd': '要件ドキュメント',
  'menu.prototypeDesign': 'プロトタイプ設計',
  'menu.prototypeDesign.brandDesign': 'ブランド設計',
  'menu.prototypeDesign.uiGuidelines': 'UIガイドライン',
  'menu.prototypeDesign.informationArchitecture': '情報アーキテクチャ',
  'menu.prototypeDesign.menuPlanning': 'メニュー計画',
  'menu.prototypeDesign.pageDesign': 'ページ設計',
  'menu.prototypeDesign.interactionFlow': 'インタラクションフロー',
  'menu.prototypeDesign.aiAssistedDesign': 'AIページ設計',
  'menu.prototypeDesign.prototypePreview': 'プロトタイププレビュー',
  'menu.architectureDesign': 'アーキテクチャ設計',
  'menu.architectureDesign.architectureOverview': 'アーキテクチャ概要',
  'menu.architectureDesign.applicationArchitecture':
    'アプリケーションアーキテクチャ',
  'menu.architectureDesign.technicalStandards': '技術標準',
  'menu.architectureDesign.dataModeling': 'データモデリング',
  'menu.architectureDesign.apiDesign': 'API設計',
  'menu.architectureDesign.permissionModel': '権限モデル',
  'menu.architectureDesign.integrationDesign': '連携設計',
  'menu.architectureDesign.adr': 'アーキテクチャ決定',
  'menu.developmentExecution.applicationManagement': 'アプリ管理',
  'menu.developmentExecution.developmentTasks': '開発タスク',
  'menu.developmentExecution.codeManagement': 'コード管理',
  'menu.developmentExecution.codeActivity': 'コード活動',
  'menu.developmentExecution.buildRecords': 'ビルド記録',
  'menu.agentsManagement': 'Agents管理',
  'menu.agentsManagement.agentWorkspace': 'Agentワークスペース',
  'menu.agentsManagement.projectAgents': 'プロジェクトAgents',
  'menu.testingQuality': 'テスト品質',
  'menu.testingQuality.testingOverview': 'テスト概要',
  'menu.testingQuality.testPlan': 'テスト計画',
  'menu.testingQuality.testCases': 'テストケース',
  'menu.testingQuality.testExecution': 'テスト実行',
  'menu.testingQuality.qualityAnalysis': '品質分析',
  'menu.testingQuality.acceptanceManagement': '検収管理',
  'menu.deploymentOperations': 'デプロイ運用',
  'menu.deploymentOperations.console': 'デプロイコンソール',
  'menu.deploymentOperations.pipelines': 'パイプライン履歴',
  'menu.deploymentOperations.runtime': 'ランタイム監視',
  'menu.deploymentOperations.coralApplicationPublication': 'アプリの掲載',
  'menu.releaseDelivery': 'リリース納品',
  'menu.releaseDelivery.versionManagement': 'バージョン管理',
  'menu.releaseDelivery.releasePlan': 'リリース計画',
  'menu.releaseDelivery.releaseRecords': 'リリース記録',
  'menu.releaseDelivery.deliverablesManagement': '納品物管理',
  'menu.releaseDelivery.coralApplicationPublication': 'アプリの掲載',
  'menu.researchReferences': '資料研究',
  'menu.researchReferences.referenceMaterials': '参考資料',
  'menu.researchReferences.competitorManagement': '競合管理',
  'menu.researchReferences.competitorAnalysis': '競合分析',
  'menu.researchReferences.competitorAnalysisReport': '競合分析レポート',
  'menu.buildingAssets': '構築補助',
  'menu.buildingAssets.imageAssets': '画像素材',
  'menu.buildingAssets.iconAssets': 'アイコン素材',
  'menu.projectAssets.projectDocuments': 'プロジェクト文書',
  'menu.projectAssets.deliverables': '納品物',
  'menu.businessManagement': '商務管理',
  'menu.businessManagement.quotationManagement': '見積管理',
  'menu.businessManagement.contractInformation': '契約情報',
  'menu.businessManagement.paymentPlan': '入金計画',
  'menu.businessManagement.changeQuotation': '変更見積',
  'menu.projectSettings.memberManagement': 'メンバー管理',
  'menu.projectSettings.projectDetail': 'プロジェクト詳細',
  'menu.projectSettings.auditLogs': '監査ログ',
  'menu.projectSettings.projectAnnouncements': 'プロジェクト告知',
  'menu.projectGoals': 'プロジェクト規約',
  'menu.projectCollection': 'プロジェクト全体',
  'menu.projectCollection.projectHome': 'プロジェクトホーム',
  'menu.projectCollection.projectGoals': 'プロジェクト規約',
  'menu.applicationManagement': 'アプリケーション管理',
  'menu.applicationManagement.repositoryManagement': 'アプリ構築',
  'menu.applicationManagement.applicationAnalysis': 'AIアプリ分析',
  'menu.application': 'アプリケーション管理',
  'menu.communication': 'コミュニケーション記録',
  'menu.requirements': '要件分析',
  'menu.requirements.requirementPool': '要件プール',
  'menu.requirements.summary': '要件概要',
  'menu.requirements.featureList': '機能一覧',
  'menu.requirements.document': '要件ドキュメント',
  'menu.requirements.roleAnalysis': 'ロール分析',
  'menu.requirements.conceptAnalysis': '概念分析',
  'menu.requirements.conceptAnalysis.management': '概念管理',
  'menu.requirements.conceptAnalysis.group': '概念グループ',
  'menu.requirements.conceptAnalysis.relation': '概念関係',
  'menu.conceptAnalysis': '概念分析',
  'menu.conceptAnalysis.management': '概念管理',
  'menu.conceptAnalysis.group': '概念グループ',
  'menu.conceptAnalysis.relation': '概念関係',
  'menu.requirements.applicationAnalysis': 'AIアプリ分析',
  'menu.requirements.projectGoals': 'プロジェクト規約',
  'menu.dataModeling': 'データモデリング',
  'menu.dataModeling.modelingAssistant': 'AI支援モデリング',
  'menu.dataModeling.entityManagement': 'エンティティ管理',
  'menu.dataModeling.ruleManagement': 'ルール管理',
  'menu.dataModeling.dataSourceManagement': 'データソース管理',
  'menu.requirements.systemIntegration': 'システム連携',
  'menu.prototype': 'ページ設計',
  'menu.architecture': 'アーキテクチャ設計',
  'menu.architecture.overview': '概要設計',
  'menu.architecture.detail': '詳細設計',
  'menu.agentManagement': 'Agent管理',
  'menu.developmentManagement': '開発管理',
  'menu.developmentManagement.agentManagement': 'Agent管理',
  // 'menu.developmentManagement.devAgentV1Planning':
  //   '開発エージェント V1 タスク計画',
  // 'menu.developmentManagement.devAgentV1':
  //   '開発エージェント V1 実行ダッシュボード',
  // 'menu.developmentManagement.projectBlueprint': 'プロジェクトブループリント',
  'menu.developmentManagement.taskManagement': '開発タスク管理',
  'menu.architecture.codeManagement': 'コード管理',
  'menu.architecture.apiManagement': 'API管理',
  'menu.codeManagement': 'コード管理',
  'menu.codeManagement.codeRepository': 'コードリポジトリ',
  'menu.codeManagement.codeMigration': 'コード移行',
  'menu.codeManagement.dependencyAnalysis': '依存関係分析',
  'menu.apiManagement': 'API管理',
  'menu.apiManagement.apiList': 'API一覧',
  'menu.apiManagement.apiQuickDebug': 'APIクイックデバッグ',
  'menu.testManagement': 'テスト管理',
  'menu.testManagement.dashboard': 'ダッシュボード',
  'menu.testManagement.bug': 'バグ',
  'menu.testManagement.case': 'テストケース',
  'menu.testManagement.suite': 'テストスイート',
  'menu.testManagement.order': 'テストオーダー',
  'menu.testManagement.report': 'テストレポート',
  'menu.testManagement.caseLibrary': 'ケースライブラリ',
  'menu.qualityManagement': '品質管理',
  'menu.qualityManagement.qualityAnalysis': '品質分析',
  'menu.knowledgeBase': '資料リンク',
  'menu.knowledgeBase.referenceProducts': '参照製品',
  'menu.knowledgeBase.referenceMaterials': '資料リンク',
  'menu.assetLibrary': '素材ライブラリ',
  'menu.projectSettings': 'プロジェクト設定',
  'menu.projectSettings.projectMember': 'プロジェクトとメンバー',
  'menu.projectSettings.projectCollaboration': 'プロジェクト協業',
  'menu.projectSettings.projectAnnouncement': 'プロジェクト告知',
  'menu.projectSettings.projectTags': 'プロジェクトタグ',
  'menu.projectSettings.developerOptions': '開発者オプション',
  'menu.workbench': 'ワークベンチ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': '管理サブページ',
  'menu.system': 'システム管理',
  'menu.system.menu': 'メニュー管理',
  'menu.system.user': 'ユーザー管理',
  'menu.system.role': 'ロール管理',
  'menu.template': 'テンプレート',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（送金情報入力）',
  'menu.form.step-form.confirm': 'ステップフォーム（送金情報確認）',
  'menu.form.step-form.result': 'ステップフォーム（完了）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '標準リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト（記事）',
  'menu.list.search-list.projects': '検索リスト（プロジェクト）',
  'menu.list.search-list.applications': '検索リスト（アプリ）',
  'menu.profile': '詳細ページ',
  'menu.profile.basic': '基本詳細',
  'menu.profile.advanced': '高度な詳細',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'エラートリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドマップエディタ',
  'menu.editor.koni': 'トポロジーエディタ',
  'menu.auditLog': '監査ログ',
  'menu.tabs.refresh': '現在のタブを更新',
  'menu.tabs.closeCurrent': '現在のタブを閉じる',
  'menu.tabs.closeOthers': '他のタブを閉じる',
  'menu.tabs.closeRight': '右側のタブを閉じる',
  'menu.tabs.closeAll': 'すべてのタブを閉じる',
  'menu.tabs.scrollLeft': '左側のタブを表示',
  'menu.tabs.scrollRight': '右側のタブを表示',
  'menu.tabs.manage': 'タブ管理',
  'menu.tabs.unnamed': '無題ページ',
  'menu.项目管理': 'プロジェクト管理',
  'menu.工时评估标准管理': '工数見積基準管理',
  'menu.开发Agent管理': '開発Agent管理',
  'menu.项目列表': 'プロジェクト一覧',
  'menu.项目主页': 'プロジェクトホーム',
  'menu.应用管理': 'アプリケーション管理',
  'menu.应用管理.搭建应用': 'アプリ構築',
  'menu.沟通记录': 'コミュニケーション記録',
  'menu.需求分析': '要件分析',
  'menu.需求分析.需求池': '要件プール',
  'menu.需求分析.需求概要': '要件概要',
  'menu.需求分析.功能清单': '機能一覧',
  'menu.需求分析.需求文档': '要件ドキュメント',
  'menu.页面设计': 'ページ設計',
  'menu.prototype.aiAssistedDesign': 'AIページ設計',
  'menu.prototype.statisticalAnalysisPageDesign': '統計分析ページ設計',
  'menu.prototype.bigScreenPageDesign': '大画面ページ設計',
  'menu.prototype.designManagement': 'ページ管理',
  'menu.prototype.themeDesign': 'テーマ設計',
  'menu.架构设计': 'アーキテクチャ設計',
  'menu.架构设计.概要设计': '概要設計',
  'menu.架构设计.详细设计': '詳細設計',
  'menu.任务管理': 'タスク管理',
  'menu.缺陷管理': '不具合管理',
  'menu.测试管理': 'テスト管理',
  'menu.质量管理': '品質管理',
  'menu.日报管理': '日報管理',
  'menu.报价管理': '見積管理',
  'menu.知识库': '参考資料',
  'menu.素材库': '素材ライブラリ',
  'menu.审计日志': '監査ログ',
  'menu.需求分析.角色分析': 'ロール分析',
  'menu.需求分析.概念分析': '概念分析',
  'menu.需求分析.应用分析': 'AIアプリ分析',
  'menu.需求分析.项目目标': 'プロジェクト規約',
  'menu.需求分析.数据建模': 'データモデリング',
  'menu.数据建模.AI辅助建模': 'AI支援モデリング',
  'menu.数据建模.实体管理': 'エンティティ管理',
  'menu.需求分析.系统对接': 'システム連携',
  'menu.taskManagement': 'タスク管理',
  'menu.defectManagement': '不具合管理',
  'menu.daily-report-management': '日報管理',
  'menu.quote-management': '見積管理',
};
